import React, { useLayoutEffect } from 'react'
import { BrowserRouter, HashRouter, Route, Switch } from 'react-router-dom'
import { ROUTER_BASENAME } from '../common/const'

import Admin from '../pages/admin'
import Login from '../pages/login'
import Verify from '../pages/Verify'
import CreateAccount from '../pages/CreateAccount'
import CreateTeam from '../pages/CreateTeam'
import Invite from '../pages/Invite'
import InviteShare from '../pages/InviteShare'
import Download from '../pages/Download'
import SelectCorp from '../pages/SelectCorp'
import SigninOrg from '../pages/SigninOrg'
import OpenApp from '../pages/OpenApp'
import TeamList from '../pages/TeamList'
import TeamListSwitch from '../pages/TeamListSwitch'
import InviteList from '../pages/InviteList'
import LoginPopupCallback from '../pages/LoginPopupCallback'
import SetPassword from '../pages/SetPassword'
import VerifyMFA from '../pages/VerifyMFA'

const Router = () => {
  return (
    <BrowserRouter basename={`/${ROUTER_BASENAME}`}>
      <Switch>
        <Route exact path="/" component={Admin} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/verify" component={Verify} />
        <Route exact path="/create_team" component={CreateTeam} />
        <Route exact path="/invite" component={Invite} />
        <Route exact path="/invite_share" component={InviteShare} />
        <Route exact path="/invite_list" component={InviteList} />
        <Route exact path="/download" component={Download} />
        <Route exact path="/select_corp" component={SelectCorp} />
        <Route exact path="/signin_org" component={SigninOrg} />
        <Route exact path="/open" component={OpenApp} />
        <Route exact path="/team_list" component={TeamList} />
        <Route exact path="/team_list_switch" component={TeamListSwitch} />
        <Route
          exact
          path="/login_popup_callback"
          component={LoginPopupCallback}
        />
        <Route exact path="/set_pwd" component={SetPassword} />
        <Route exact path="/verify_mfa" component={VerifyMFA} />
      </Switch>
    </BrowserRouter>
  )
}

export default Router
